import { CommonService } from './../../../services/common.service';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { CheckOutService } from './../../../services/checkout.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CheckoutViewModel } from '../../../models/check-out.model';
import { ShippingAddressViewModel } from '../../../models/shopping-cart.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { CartItem } from '../../../models/cart-item.model';
import { map, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-donation',
  templateUrl: './donation.component.html',
  styleUrls: ['./donation.component.css'],
})
export class DonationComponent implements OnInit, OnDestroy {
  title = 'Donation';
  treesPlantedNumber = 12000;
  strTreesPlanted = '';
  selectedValue = 0;
  cartId = '';
  cartName = '';
  isTenantRequired = true;
  checkoutViewModel: CheckoutViewModel;
  shippingAddressModel: ShippingAddressViewModel;
  serial: string;

  backto: string;

  quoteId: string;

  ngUnsubscribe: Subject<void> = new Subject<void>();
  loadContent: boolean = false;

  donationOptionsList = [
    {
      value: 1,
      description: 'towards tree planting initiatives',
      stockCode: 'Tree1',
    },
    {
      value: 5,
      description: 'towards tree planting initiatives',
      stockCode: 'Tree5',
    },
    {
      value: 10,
      description: 'towards tree planting initiatives',
      stockCode: 'Tree10',
    },
  ];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private checkOutService: CheckOutService,
    private commonService: CommonService,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    this.activatedRoute.parent.url.subscribe(
      (value) => {
        this.cartId = value.length > 1 ? value[1].path : '';
        this.cartName = value.length > 1 ? value[2].path : '';
      },
      (error: any) => {
        console.error(error);
      }
    );
    // this.strTreesPlanted = this.treesPlantedNumber.toLocaleString('en', {useGrouping: true});
    // this.getTotalDonation();
    this.getDonationItem();

    // this.activatedRoute.parent.parent.paramMap
    //   .takeUntil(this.ngUnsubscribe)
    //   .subscribe((params) => {
    //     this.serial = params.get('serial');
    //   });

    this.activatedRoute.parent.parent.parent.paramMap.pipe(
      switchMap((params) => {
        return this.activatedRoute.parent.parent.paramMap.pipe(
          map((param) => {
            return {
              quoteId: params.get('sku'),
              serial: param.get('serial'),
            }
          })
        )
      })
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      this.quoteId = res.quoteId;
      this.serial = res.serial;
      if (this.quoteId) {
        this.backto = 'quote';
      } else if (this.serial) {
        this.backto = 'renewal';
      } else {
        this.backto = 'cart';
      }
    })



    this.checkOutService.currentCheckoutViewModel
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: CheckoutViewModel) => {
        this.checkoutViewModel = res;
      });

    this.checkOutService.passModelWatch.subscribe(
      (res: ShippingAddressViewModel) => {
        this.shippingAddressModel = res;
      },
      (error: any) => {
        console.error(error);
      }
    );

    const isAutoPilotTenantRequired = localStorage.getItem('autoPilotTenant');
    if (isAutoPilotTenantRequired) {
      this.isTenantRequired =
        isAutoPilotTenantRequired === 'YES' ? true : false;
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  getDonationItem() {
    this.loadContent = false;
    this.checkOutService
      .GetDonationItem(this.commonService.toNumber(this.cartId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (value: CartItem) => {
          this.loadContent = true;
          if (value) {
            this.selectedValue = value.totalPrice;
          }
        },
        (error: any) => {
          this.loadContent = true;
          console.log(error);
        }
      );
  }

  goToFNPWLink() {
    const url = 'https://www.dickerdata.com.au/fnpw';
    window.open(url, '_blank');
  }

  // getTotalDonation() {
  //   this.checkOutService.GetTotalDonation().takeUntil(this.ngUnsubscribe)
  //     .subscribe((value: string) => {
  //       this.strTreesPlanted = value;
  //     });
  // }

  selectDonation(value: number) {
    this.selectedValue = value;
    this.loadContent = false;
    this.checkOutService
      .UpsertDonation(this.commonService.toNumber(this.cartId), value)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          if (response) {
            this.commonService.implementToast(
              'Thank you for your donation.',
              'Success'
            );
          }
          this.loadContent = true;
        },
        (error: any) => {
          this.loadContent = true;
          console.log(error);
        }
      );
  }

  goPrevious(): void {
    if (
      this.isTenantRequired &&
      this.checkoutViewModel &&
      this.checkoutViewModel.tenantDetailsRequired === 'YES' &&
      (this.checkoutViewModel.firstStep === 'TENANT' ||
        this.checkoutViewModel.firstStep === 'NOENDUSER')
    ) {
      // LoadSection("TENANT");
      this.router.navigate(['tenant'], {
        relativeTo: this.activatedRoute.parent,
      });
    } else if (
      this.checkoutViewModel &&
      this.checkoutViewModel.tenantDetailsRequired === 'YES' &&
      this.checkoutViewModel.firstStep === 'ENDUSER'
    ) {
      this.router.navigate(['end-user'], {
        relativeTo: this.activatedRoute.parent,
      });
    } else if (
      (this.shippingAddressModel &&
        !this.shippingAddressModel.collectTheOrder &&
        this.checkoutViewModel.firstStep === 'ENDUSER') ||
      (this.shippingAddressModel &&
        this.shippingAddressModel.collectTheOrder &&
        this.checkoutViewModel.firstStep === 'ADDRESS') ||
      (this.checkoutViewModel.allFreightFreeProducts === 'YES' &&
        this.checkoutViewModel.containsDirectShippingProducts !== 'NO')
    ) {
      // LoadSection("ENDUSER");
      this.router.navigate(['end-user'], {
        relativeTo: this.activatedRoute.parent,
      });
    } else if (
      (this.shippingAddressModel &&
        this.shippingAddressModel.collectTheOrder &&
        this.checkoutViewModel.firstStep === 'NOENDUSER') ||
      (this.shippingAddressModel &&
        this.shippingAddressModel.collectTheOrder &&
        this.checkoutViewModel.containsDirectShippingProducts === 'YES')
    ) {
      // LoadSection("ADDRESS");
      this.router.navigate(['ship-address'], {
        relativeTo: this.activatedRoute.parent,
      });
    } else {
      this.router.navigate(['freight-ship'], {
        relativeTo: this.activatedRoute.parent,
      });
    }
  }

  moveToNext() {
    if (this.selectedValue === undefined) {
      this.commonService.implementToast(
        'Please select your donation option',
        'Info'
      );
      return;
    }
    this.router.navigate(['payment-method'], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  backtoCart() {
    this.checkOutService.monitorShowCartSummary('show');
    this.router.navigateByUrl(`/myCarts/cart/${this.cartId}/${this.cartName}`);
  }

  backtoRenewals() {
    this.router.navigate(['.'],{relativeTo:this.activatedRoute.parent.parent});

    // this.router.navigateByUrl(
    //   `manageRenewalsNew/renewalDetails/${this.serial}`
    // );
  }

  backtoQuotes() {
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent.parent });
    $('.combination-loader').animate(
      { scrollLeft: (250 + $('#price-list-detail').width()) }, 100)

  }

  close() {
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
